import { DEFAULT_ENDPOINT } from "constants/variables";
import { requestPagedFaqs, receivePagedFaqs } from "./faq.creators";

const ENDPOINT = `${DEFAULT_ENDPOINT}/faq`;
const PER_PAGE = 50;

const getPagedFaqs = () => {
    return dispatch => {
        dispatch(requestPagedFaqs());
        let currentPage = 1;
        fetch(`${ENDPOINT}/?per_page=${PER_PAGE}&page=${currentPage}`)
            .then(res => {
                const totalPages = res.headers.get("X-WP-TotalPages");
                currentPage++;

                let pagingEndpoints = [res.json()];
                for (currentPage; currentPage <= totalPages; currentPage++)
                    pagingEndpoints.push(
                        fetch(
                            `${ENDPOINT}?per_page=${PER_PAGE}&page=${currentPage}`
                        ).then(res => res.json())
                    );

                return Promise.all(pagingEndpoints);
            })
            .then(json => {
                const results = [].concat.apply([], json);
                dispatch(receivePagedFaqs(results));
            });
    };
};

export { getPagedFaqs };



// WEBPACK FOOTER //
// ./src/actions/faq/faq.functions.js